import { KUBRA_CLIENT_CODE, KUBRA_CLIENT_ID, KUBRA_CLIENT_NAME } from "./kubra-analytics";

export function kubraEnrichEventsPlugin() {
  return {
    name: "kubra-enrich-events-plugin",
    trackStart: ({ payload }: { payload: any }) => {
      if (sessionStorage.getItem(KUBRA_CLIENT_ID)) {
        payload.properties = {
          ...payload.properties,
          kubra_client_id: sessionStorage.getItem(KUBRA_CLIENT_ID),
          kubra_client_code: sessionStorage.getItem(KUBRA_CLIENT_CODE),
          kubra_client_name: sessionStorage.getItem(KUBRA_CLIENT_NAME),
        };
      }
    },
    loaded: () => true,
  };
}
